import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { nanoid } from 'nanoid'

import { UserAuthorityType } from 'entities/user/module'

import { AppIcon } from 'shared/ui/app-icon'

import { Props, TypesPagesModuleRouterList } from '../../module'

import s from './styles.module.scss'

export const Chips = ({
  active,
  isTicket,
  isDevUser,
  authorityType,
  onClick,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('container', s.container)}>
      {TypesPagesModuleRouterList?.map((tab) => {
        if (!tab) return

        if (tab.isHideMainMyTicker && isTicket) return

        if (tab?.isForDevUsers && !isDevUser) return

        if (
          authorityType &&
          tab?.hideForUserAuthorityType?.includes(
            authorityType as UserAuthorityType,
          )
        )
          return null

        const activeTab = tab.module === active
        return (
          <div
            key={nanoid()}
            className={s.tab}
            onClick={() => onClick(tab.module)}
            style={activeTab ? { backgroundColor: tab.color } : {}}
          >
            <AppIcon
              id={tab.icon}
              className={clsx(s.icon, activeTab && s.iconActive)}
            />

            <p className={clsx(s.name, activeTab && s.activeName, 'medium-16')}>
              {t(tab.module)}
            </p>

            {tab?.isNew && (
              <span className={clsx('semi-bold-11', s.newTab)}>New🔥</span>
            )}
          </div>
        )
      })}
    </div>
  )
}
